import { required, requiredIf } from 'vuelidate/lib/validators';
import ToolkitMixin from '@/app/mixins/toolkit/item';

const insurancePurposes = [
  {
    opt: 'Yes',
    value: 'to allow the Fund to repay limited recourse loans in the event of the death, disablement or terminal illness of one or more members',
  },
  {
    opt: 'Yes',
    value: 'to provide liquidity to meet death benefit payments',
  },
  {
    opt: 'Yes',
    value: 'to supplement the benefits payable to members in the event of their death, disablement or terminal illness',
  },
  {
    opt: 'No',
    value: 'given their ages and financial position, the members have advised that no insurance is required',
  },
  {
    opt: 'No',
    value: 'the members have advised that they hold sufficient insurance outside the fund for their needs',
  },
  {
    opt: 'both',
    value: 'other',
  },
];

const policiesMap = {
  yes: 'Yes',
  no: 'No',
  only: 'Only if requested by members',
};

export default {
  name: 'inv-strat-insurance',
  mixins: [ToolkitMixin],
  data: () => ({
    insurancePurposes,
  }),
  computed: {
    insurancePurposeList() {
      if (this.policies === 'Only if requested by members' || this.policies === '') {
        return [];
      }
      return this.insurancePurposes.filter(value => (value.opt === this.policies || value.opt === 'both'));
    },
    policies: {
      get() {
        return policiesMap[this.getItem.insurance.policies] || '';
      },
      set(value) {
        let convertPolicesToStore;
        Object.entries(policiesMap).forEach(([key, val]) => {
          if (val === value) {
            convertPolicesToStore = key;
          }
        });

        this.setItem({
          replace: true,
          insurance: {
            policies: convertPolicesToStore,
            purpose: [],
            other: '',
          },
        });
      },
    },
    insurancePurposeSelection: {
      get() {
        return this.getItem.insurance.purpose;
      },
      set(value) {
        this.setItem({
          insurance: {
            purpose: value,
          },
        });
      },
    },
    other: {
      get() {
        return this.getItem.insurance.other;
      },
      set(value) {
        this.setItem({
          insurance: {
            other: value,
          },
        });
      },
    },
  },
  methods: {
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleBackStep() {
      this.$emit('backStep');
    },
  },
  validations: {
    policies: {
      required,
    },
    insurancePurposeSelection: {
      required: requiredIf(function insurancePurposeSelectionRequired() {
        if (this.policies === 'Only if requested by members') {
          return false;
        }
        return true;
      }),
    },
    other:
      {
        required: requiredIf(function otherRequired() {
          if (this.insurancePurposeSelection.findIndex(value => value === 'other') >= 0) {
            return true;
          }
          return false;
        }),
      },
  },
};
